import React, { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import * as _ from 'lodash';
import DirectorLists from './DirectorLists';
import AddDirectors from './AddDirectors';

const Directors = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const [preValues, setPrevAlues] = useState(values.preValues());

  useEffect(() => {
    if (
      _.get(preValues, 'companyDetails.companyType', false) ==
        'Proprietorship' ||
      _.get(preValues, 'companyDetails.companyType', false) == 'Partnership'
    ) {
      handleSubmit();
    }
  }, []);
  const [actionOnProgess, setActionOnDirectorPage] = useState('viewDir');
  return (
    <div className="w-full">
      {actionOnProgess == 'viewDir' ? (
        <DirectorLists setActionOnDirectorPage={setActionOnDirectorPage} />
      ) : null}
      {actionOnProgess == 'addDir' ? (
        <AddDirectors setActionOnDirectorPage={setActionOnDirectorPage} />
      ) : null}
    </div>
  );
};

export default Directors;
